import { combineReducers } from 'redux';

import ModelState from 'store/ModelState';
import AppState from 'store/AppState';
import UIState from 'store/UIState';
import RouteState from 'store/RouteState';
import models from 'store/models/models';
import ListState from 'store/ListState';

ModelState.init(models);
ListState.init(models);

const reducer = combineReducers({
  app: AppState.reducer,
  models: ModelState.reducer,
  lists: ListState.reducer,
  ui: UIState.reducer,
  route: RouteState.reducer,
});
export { reducer as default };